import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';
import { cn } from '@/lib/utils';
import { redirectService } from '@/lib/redirect';
import { X } from 'lucide-react';
import { useRouter } from 'next/navigation';

interface RegisterDialogProps {
  title: string;
  description: string;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  children?: React.ReactNode;
  redirectToAddStory?: boolean; // New prop to indicate if we should redirect to add-story
  questionTypeUrl?: string; // The question type URL for the redirect
  redirectUrl?: string; // Custom redirect URL (e.g., /ask-question)
}

export default function RegisterDialog({
  title,
  description,
  open,
  onOpenChange,
  children,
  redirectToAddStory = false,
  questionTypeUrl,
  redirectUrl,
}: RegisterDialogProps) {
  const router = useRouter();
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogTrigger onClick={(e) => e.stopPropagation()} asChild>
        {children}
      </AlertDialogTrigger>
      <AlertDialogContent className="w-[400px]">
        <AlertDialogCancel
          className="absolute top-2 right-2 border-0 bg-transparent shadow-none"
          onClick={() => onOpenChange?.(false)}
        >
          <X className="h-5 w-5 text-ihs-dark-blue" />
        </AlertDialogCancel>
        <AlertDialogHeader>
          <AlertDialogTitle className="text-base font-bold text-ihs-dark-blue">
            {title}
          </AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter className="flex justify-between">
          <AlertDialogAction
            className={cn(
              'uppercase font-bold flex-1 w-full bg-ihs-blue text-white hover:bg-ihs-dark-blue/90'
            )}
            onClick={() => {
              // Priority: redirectUrl > redirectToAddStory > current URL
              if (redirectUrl) {
                // Use custom redirect URL (e.g., /ask-question)
                redirectService.saveRedirect(redirectUrl);
              } else if (redirectToAddStory && questionTypeUrl) {
                // If redirectToAddStory is true, save the add-story URL with question type
                redirectService.saveRedirect(
                  `/add-story/new?redirectTo=${questionTypeUrl}`
                );
              } else {
                // Otherwise, save the current URL
                const currentUrl =
                  window.location.pathname + window.location.search;
                redirectService.saveRedirect(currentUrl);
              }

              router.push('/sign-up');
            }}
          >
            Join Now - It&apos;s Free
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
